<div class="ui-loading-dialog--container text-center">
  <div class="title text-large mb-2">{{ title }}</div>
  <div *ngIf="message" class="message text-medium mb-2">{{ message }}</div>
  <div class="loading-indicator">
    <div
      class="overlay"
      lumAppLoader
      [loading]="true"
      [classes]="'loading blur'"
    ></div>
  </div>
</div>
